/**
 * External dependencies
 */
import { View } from 'react-native';

/**
 * GeChiUI dependencies
 */
import { TextControl } from '@gechiui/components';
import { withPreferredColorScheme } from '@gechiui/compose';
import { useMemo } from '@gechiui/element';

/**
 * Internal dependencies
 */
import styles from './actions.scss';
import BottomSeparatorCover from './bottom-separator-cover';

function PanelActions( { actions, getStylesFromColorScheme } ) {
	const mappedActions = useMemo( () => {
		return actions.map( ( { label, onPress } ) => {
			return (
				<TextControl
					label={ label }
					onPress={ onPress }
					labelStyle={ styles.defaultLabelStyle }
					key={ label }
				/>
			);
		} );
	}, [ actions ] );

	return (
		<View
			style={ getStylesFromColorScheme(
				styles.panelActionsContainer,
				styles.panelActionsContainerDark
			) }
		>
			{ mappedActions }
			<BottomSeparatorCover />
		</View>
	);
}

export default withPreferredColorScheme( PanelActions );
